<template lang="pug">
	v-container(fluid class=" tw-w-full tw-h-full")
		v-row()
			v-col()
				template(v-if="error == 404")
					v-lottie-player(
						:loop="false"
						width="100%"
						height="100%"
						:animation-data="require('@/assets/animations/404-not-found.json')"
					)
</template>
<script>
export default {
	computed:{
		error(){
			return this.$store.getters['error'].response.status
		}
	},
	watch:{
		error(a, b){
			console.log(a)
		}
	}
}
</script>